// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e582bd0b","453":"5bffab02"}[chunkId] + ".chunk.js";
};